import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,  // CRITICAL: Include cookies in requests
  headers: {
    'Content-Type': 'application/json'
  }
});

// Response interceptor for handling auth errors
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // Clear local user data
      localStorage.removeItem("admin_addislearning_user");

      // Only redirect if not already on login page and not during auth check
      const isAuthCheck = error.config?.url?.includes('/adminAuth/me');
      const isOnLoginPage = window.location.pathname === '/';

      if (!isAuthCheck && !isOnLoginPage) {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

/**
 * Extracts a displayable error message from API error response.
 * Prevents "Objects are not valid as React child" by never returning objects.
 */
export function extractErrorMessage(error, fallback = 'An error occurred') {
  if (!error) return fallback;
  if (error.message === 'Network Error') return 'Network Error';
  const data = error?.response?.data;
  if (!data) return fallback;
  if (typeof data === 'string') return data;
  if (data.errMessage) return data.errMessage;
  if (data.message) return data.message;
  if (data.data && typeof data.data === 'string') return data.data;
  if (data.errors) {
    const first = Object.values(data.errors)[0];
    if (Array.isArray(first) && first[0]) return first[0];
    if (typeof first === 'string') return first;
  }
  return fallback;
}

export default api;
